<div *ngIf="selectedRequest">
  <div [formGroup]="requestForm" *ngIf="requestForm && isBookingIdsReady">
    <p-toast></p-toast>
    <div class="top-container">
      <h3>
        Edit refund request
      </h3>
      <p-button label="Add Booking" (onClick)="addBookingIdControl()"></p-button>
    </div>
    <div class="form-table-container">
      <table>
        <tr>
          <td width="200">
              Booking ID:
          </td>
          <td>
            <div formArrayName="bookingIdArray" class="id-array-container">
              <div *ngFor="let control of bookingIdArray.controls; let i = index" class="booking-id-container">
                <p-dropdown placeholder="--" [filter]="true" filterBy="label" [options]="bookingIds" [formControlName]="i"
                  [style]="{'width': '124px'}" (onChange)="onBookingIdChange()"></p-dropdown>
                  <p-button *ngIf="control.value" icon="pi pi-external-link" label="Booking detail" (onClick)="openBooking(control.value)"></p-button>
                  <p-button (onClick)="deleteBookingIdControl(i)" icon="pi pi-trash"
                  styleClass="p-button-danger"></p-button>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            Student name:
          </td>
          <td class="student-name-container">
            <span>{{studentName}}</span>
          </td>
        </tr>
        <tr>
          <td>
            Amount
          </td>
          <td>
            <p *ngIf="requestForm.get('amount')!.errors && requestForm.get('amount')!.errors!['wrongNumberFormat']"
              class="global-warning">Wrong number format</p>
            <input pInputText formControlName="amount">
            <p-dropdown formControlName="currency" [options]="currencies" optionLabel="isoCode"></p-dropdown>
          </td>
        </tr>
        <tr>
          <td>
            Requested by:
          </td>
          <td>
            {{selectedRequest.requestedBy.name}}
          </td>
        </tr>
        <tr>
          <td>
            Reason for refund:
          </td>
          <td>
            <textarea pInputTextarea formControlName="reason" class="reason-input"></textarea>
          </td>
        </tr>
        <tr>
          <td>
            Account holder name:
          </td>
          <td>
            <input pInputText type="text" formControlName="accountHolderName" class="account-holder-input">
          </td>
        </tr>
        <tr>
          <td>
            IBAN:
          </td>
          <td>
            <input pInputText type="text" formControlName="iban" class="iban-input">
          </td>
        </tr>
        <tr>
          <td>
            BIC:
          </td>
          <td>
            <input pInputText type="text" formControlName="bic">
          </td>
        </tr>
        <tr>
          <td>
            Approved:
          </td>
          <td>
            <p-checkbox [formControl]="requestForm.controls['isApproved'] | formControl" [binary]="true" [readonly]="true"></p-checkbox>
          </td>
        </tr>
        <tr *ngIf="userService.hasRole('refund_request_validator') && !selectedRequest.isApproved">
          <td></td>
          <td>
            <p-button label="Approve this request" (onClick)="approveRequest()"></p-button>
          </td>
        </tr>
        <tr>
          <td>
            Paid already:
          </td>
          <td>
            <p-checkbox [formControl]="requestForm.controls['isPaid'] | formControl" [binary]="true" [readonly]="true"></p-checkbox>
            <span *ngIf="selectedRequest.isPaid">Paid by: {{selectedRequest.paidBy?.name}}</span>
          </td>
        </tr>
        <tr *ngIf="userService.hasRole('outgoing_payment_encoder') && !selectedRequest.isPaid">
          <td></td>
          <td>
            <p-button label="Mark as paid" (onClick)="encodeRefundPayment()"></p-button>
          </td>
        </tr>
      </table>
    </div>
    <p-button (onClick)="sendForm()" [disabled]="requestForm.invalid" label="Save changes"></p-button>
  </div>
</div>